// nodes/inputNode.js
import { BaseNode } from "../baseNode";
import { nodeConfigs } from "../nodeConfigs";

export const InputNode = ({ id, data }) => (
  <BaseNode id={id} data={data} config={nodeConfigs.customInput} />
);
